import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { CTALink } from '@components/CTALink';
import { animationTransition } from '@utils/animationTransition';
import { themeSpace, themeMediaQuery, themeColor } from '@utils/styledTheme.util';
import { css } from '@styledComponents';

export const StyledValuePropText = styled(Text)`
  color: ${themeColor('neutra6')};
  font-size: 17px;
  margin-top: ${themeSpace(4)};
  line-height: 27px;
  transition: ${animationTransition('color')};
`;

export const StyledValuePropDescription = styled(Text)`
  color: ${themeColor('neutra6')};
  font-size: 17px;
  margin-top: ${themeSpace(4)};
  line-height: 27px;
`;

const StyledValuePropItemStyles = css`
  display: inline-block;
  text-align: center;
  span {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledValuePropAncorItem = styled(CTALink)`
  ${StyledValuePropItemStyles};
  :hover ${StyledValuePropText} {
    color: ${themeColor('neutra5')};
  }
  :hover svg {
    color: ${themeColor('neutra4')};
  }
  :active svg,
  :active ${StyledValuePropText} {
    color: ${themeColor('neutra6')};
  }
  :active svg {
    color: ${themeColor('neutra5')};
  }
`;

export const StyledValuePropTextItem = styled(Text)`
  ${StyledValuePropItemStyles};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  svg {
    color: ${themeColor('neutra6')};
  }
`;

export const StyledValuesProp = styled.div<{ maxWidth?: string }>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: ${themeSpace(6)} ${themeSpace(5)};
  max-width: 770px;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '770px')};
  width: 100%;
  background-color: white;
  border-radius: ${themeSpace(4)};
  position: relative;
  margin: -5rem auto 0;
  padding: ${themeSpace(7)} ${themeSpace(7)} calc(${themeSpace(7)} + ${themeSpace(1)});
  z-index: 99;

  ${themeMediaQuery('below_sm')} {
    grid-template-columns: 1fr 1fr;
    border-radius: ${themeSpace(8)};
    padding-top: ${themeSpace(8)};
  }
`;
